<template>
    <div>
        <div v-if="ShopItem.out_of_production == 0" class="uk-card uk-card-default uk-card-small">

            <!--<header class="uk-card-header">
                Цены
            </header>-->

            <div class="uk-card-body">


                <!-- Prices -->
                <div class="uk-flex uk-flex-between uk-text-xsmall uk-text-muted">

                    <div>Кол-во</div>

                    <div>Цена</div>

                </div>

                <div class="tm-prices uk-text-small uk-margin-xsmall-top">
                    <ul class="uk-list">

                        <product-price-row v-for="ProductPrice in ProductPrices[ShopItemId]"
                                           :key="ProductPrice.ShopItemPrice.id"
                                           :price="ProductPrice.ShopItemPrice"
                                           :currency="ProductPrice.ShopCurrency"
                                           :type="ProductPrice.ShopItemPriceType"
                                           :is-selected="ProductPrice.ShopItemPrice.id === selectedProductPrice.ShopItemPrice.id">
                        </product-price-row>

                    </ul>
                </div>

                <!-- Add to cart -->
                <div class="uk-grid-small uk-margin-small-top" uk-grid>

                </div>
            </div>

            <footer class="uk-card-footer">
                <!-- InStock -->
                <div v-if="hasQuantity === true">
                    <div class="tm-label-block">
                        <span v-for="ShopItemWarehouse in ShopItemWarehouses" class="uk-label uk-label-success">В наличии {{ ShopItemWarehouse.quantity }} шт.</span>
                    </div>
                </div>
                <div v-else>
                    <div class="tm-label-block">
                        <span class="uk-label uk-label-success">Срок изготовления 4-6 недель</span>
                    </div>
                </div>
                <!-- Add to cart -->
                <div class="uk-grid-small uk-margin-small-top" uk-grid>


                    <div v-show="!inCart" class="uk-flex uk-flex-inline">
                        <input v-model.number="quantity" class="uk-input uk-text-center tm-quantity-input">
                        <div class="tm-quantity-buttons">
                            <button @click="plus" class="tm-inc-button uk-flex uk-flex-center uk-flex-middle"><span uk-icon="plus"></span></button>
                            <button @click="minus" class="tm-dec-button uk-flex uk-flex-center uk-flex-middle"><span uk-icon="minus"></span></button>
                        </div>
                    </div>

                    <div v-show="!inCart" class="uk-width-expand">
                        <button :disabled="!canBuy"
                                @click="buy(quantity,ShopItem)"
                                class="uk-button uk-button-primary uk-width-1-1">
                            <span uk-icon="icon: cart"></span> Купить
                        </button>
                    </div>

                    <div v-show="inCart" class="uk-width-expand">
                        <a href="/cart" class="uk-button uk-button-primary uk-width-1-1">
                            <span>В корзине</span>
                        </a>
                    </div>

                </div>
            </footer>

        </div>

        <div v-else class="uk-card uk-card-default uk-card-small" style="border: 2px solid #8C4C4C;">

            <div class="uk-card-body uk-text-center">
                <div class="uk-text-danger uk-text-bold">Товар снят с производства</div>
                <div class="uk-text-primary">Звоните, мы поможем подобрать аналог!</div>
                <div class="uk-flex uk-flex-middle uk-flex-center tm-contact-phone">
                    <span uk-icon="icon: phone; ratio: 1.4" class="uk-text-muted uk-icon"></span><a href="tel:+78126221770" class="uk-text-lead uk-link-text">+7 (812) 622-17-70</a>
                </div>
            </div>

            <footer v-if="RelatedItemsCount > 0" class="uk-card-footer">
                <a href="#relatedproducts" uk-scroll="" class="uk-button uk-button-primary uk-width-1-1">Похожие товары</a>
            </footer>

        </div>
    </div>
</template>

<script>
    import ProductPriceRow from "./ProductPriceRow";
    export default {
        name: "Prices",
        components: {ProductPriceRow},
        props: {
            ShopItem: {
                type: Object,
                required: true
            },
            ShopItemWarehouses: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ShopOrderItems: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            ProductPrices: {
                type: [Array, Object],
                default() {
                    return []
                }
            },
            RelatedItemsCount: {
                type: Number,
                default() {
                    return 0
                }
            }
        },
        data() {
            let qty = this.ProductPrices[this.ShopItem.id][0].ShopItemPrice.price_break;
            return {
                quantity: qty ? qty : 1,
                ShopItemId: this.ShopItem.id,
                selectedProductPrice: {},
                iShopOrderItems: this.ShopOrderItems,
                loading: true
            }
        },
        watch: {
            quantity: {
                immediate: true,
                handler(newVal, oldVal) {
                    this.ProductPrices[this.ShopItemId].map((ProductPrice) => {
                        if (this.quantity >= ProductPrice.ShopItemPrice.price_break) {
                            this.selectedProductPrice = ProductPrice;
                        }
                    });
                }
            }
        },
        computed: {
            canBuy() {
                return Number.isInteger(this.quantity) && this.quantity > 0;
            },
            inCart() {
                if(this.iShopOrderItems[this.ShopItemId]){
                    return !!this.iShopOrderItems[this.ShopItemId].shop_item_id;
                }
            },
            hasQuantity() {
                return this.ShopItemWarehouses.some((warehouse)=>{
                    return warehouse.quantity > 0
                })
            },
        },
        methods: {
            buy(quantity, ShopItem) {
                this.loading = true;
                this.$http.put('/cart/buy', {
                    quantity: quantity,
                    shopItemId: ShopItem.id
                }).then(
                    (response) => {
                        this.iShopOrderItems = response.body.data.shopOrderItems;
                        this.loading = false;
                        this.$bus.$emit('update-navbar-cart');
                    }
                )

            },
            plus() {
                this.quantity = parseInt(this.quantity) + 1;
            },
            minus() {
                if(parseInt(this.quantity) > 1){
                    this.quantity = parseInt(this.quantity) - 1;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Prices.vue?ada045a6